import { Component, Input } from '@angular/core';

export const FONT_SIZE_DEFAULT = '16';
export const FONT_WEIGHT_DEFAULT = '400';

@Component({
    selector: 'app-mdr-title',
    templateUrl: './mdr-title.component.html',
    styleUrls: ['./mdr-title.component.scss'],
    standalone: false,
})
export class MdrTitleComponent {
    /**
     * @var fontSize: the font size of the title as a string
     * By default is set to 16px
     */
    @Input() public fontSize = FONT_SIZE_DEFAULT;

    /**
     * @var fontWeight: the font weight of the title as a string
     * By default is set to 300
     */
    @Input() public fontWeight = FONT_WEIGHT_DEFAULT;

    /**
     * @var marginBottom: the bottom margin from the value
     */
    @Input() public marginBottom = 0;
}
